import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { signOut, type User } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth } from '@/config/firebase';
import { db } from '@/config/firebase';

const getCurrentUser = (): Promise<User | null> => {
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user: User | null) => {
      unsubscribe();
      resolve(user);
    });
  });
};

const hasAdminAccess = async (uid: string): Promise<boolean> => {
  const adminRef = doc(db, 'admins', uid);
  const adminSnap = await getDoc(adminRef);
  return adminSnap.exists();
};

export const requireAdmin = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const user = await getCurrentUser();

  if (!user) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
    return;
  }

  try {
    const isAdmin = await hasAdminAccess(user.uid);
    if (isAdmin) {
      next();
      return;
    }
    await signOut(auth);
    next({
      path: '/login',
      query: { denied: '1', redirect: to.fullPath }
    });
  } catch (err) {
    console.error('Error validating admin access:', err);
    next('/login');
  }
};
